<script setup lang="ts"></script>

<template>
  <icon name="lucide:trash-2" />
</template>

<style scoped></style>
